<template>
    <div class="event-selector">
        <div class="event-selector-toolbar">
            <div class="field">
                <label>Automation Name: </label>
                <a-input v-model="automationName" placeholder="Automation Name" />
            </div>

            <div class="field">
                <label>Supsis Object: </label>
                <a-select v-model="selectedModule" placeholder="Select a module">
                    <a-select-option v-for="module in modules" :key="module" :value="module">
                        {{ module }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <a-divider />
        <SupsisTable
            :columns="getCols()"
            :rows="getEvents()"
            top-pagination
            empty-data-bordered
            bottom-pagination
            :pagination-cursor="pagination"
            :options="{
                checkboxOption,
                rowStyleOption,
                clipboardOption,
                fixedHeader: true,
                id: 'events-table',
                borderX: true,
                borderY: true,
            }"
            @cursor-changed="(cursor) => (pagination = cursor)"
        />
    </div>
</template>
<script>
import Vue from "vue";
import SupsisTable from "../../../../components/SupsisTable.vue";
import moment from "moment";
import SupsisButton from "../../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "EventSelector",
    components: { SupsisTable, SupsisButton },
    data() {
        return {
            automationName: "Untitled Automation 🚀",
            selectedModule: "chat",
            selectedEvent: null,
            modules: [
                "chat",
                "contact",
                "email",
                "task",
                "event",
                "meta-lead",
                "agent",
                "invoice",
                "whatsapp",
                "reservation",
                "chatbot",
                "webhook",
            ],
            events: [
                {
                    module: "webhook",
                    event: "webhook.catch",
                    description: "When a webhook is triggered",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chat",
                    event: "chat.created",
                    description: "When a chat is created",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chat",
                    event: "chat.closed",
                    description: "When a chat is closed",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chat",
                    event: "chat.rated",
                    description: "When a chat is rated",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "contact",
                    event: "contact.created",
                    description: "When a new contact is created",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "email",
                    event: "email.received",
                    description: "When a new email is received",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "task",
                    event: "task.created",
                    description: "When a new task is created",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "meta-lead",
                    event: "meta-lead.created",
                    description: "When a new meta-lead is created",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "agent",
                    event: "agent.created",
                    description: "When a new agent is created",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "invoice",
                    event: "invoice.created",
                    description: "When a new invoice is created",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "whatsapp",
                    event: "whatsapp.message-received",
                    description: "When a new whatsapp message is received",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "reservation",
                    event: "reservation.created",
                    description: "When a new reservation is created",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
                {
                    module: "chatbot",
                    event: "chatbot.message-received",
                    description: "When a new chatbot message is received",
                    payload: {
                        filter: {
                            all: true,
                        },
                    },
                },
            ],
            checkboxOption: {
                selectedRowKeys: [],
                // row select change event
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    console.log("selectedRowChange", { row, isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
                // selected all change event
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    console.log("selectedAllChange", { isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
            },
            rowStyleOption: {
                stripe: true,
            },
            clipboardOption: {
                copy: true,
                paste: false,
                cut: false,
                delete: false,
            },
            pagination: {
                page: 1,
                perPage: 20,
                total: 0,
                defaultPageSize: 50,
                hideOnSinglePage: true,
                pageSizeOptions: [10, 15, 20, 50, 100],
                showQuickJumper: true,
                showSizeChanger: true,
            },
        };
    },
    methods: {
        save() {
            const meta = this.events.find((event) => event.event === this.selectedEvent);
            this.$emit("save", {
                name: this.automationName,
                event: this.selectedEvent,
                payload: meta.payload,
            });
        },
        selectEvent(event) {
            this.selectedEvent = event;
            this.save();
        },
        getCols() {
            return [
                {
                    key: "module",
                    field: "module",
                    title: "Module",
                    width: "",
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.module}</span>;
                    },
                },
                {
                    key: "Event",
                    field: "event",
                    title: "Event",
                    width: "",
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.event}</span>;
                    },
                },

                {
                    key: "description",
                    field: `description`,
                    title: "Description",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.description}</span>;
                    },
                },
                {
                    title: "Action",
                    key: "operation",
                    width: "100px",
                    align: "center",
                    operationColumn: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div class="actions">
                                <SupsisButton onClick={() => this.selectEvent(row.event)} ghost primary>
                                    Select
                                </SupsisButton>
                            </div>
                        );
                    },
                },
            ];
        },
        getEvents() {
            return this.events.filter((event) => {
                if (this.selectedModule) {
                    return event.module === this.selectedModule;
                }
                return true;
            });
        },
    },
    watch: {
        selectedModule() {
            this.pagination.page = 1;
            if (this.automationName.includes("Untitled")) {
                this.automationName = `Untitled ${this.selectedModule} Automation 🚀`;
            }
        },
    },
});
</script>

<style scoped lang="scss">
.event-selector {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .event-selector-toolbar {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;

        .field {
            display: flex;
            align-items: baseline;
            gap: 5px;
        }

        label {
            font-weight: 700;
            font-size: 16px;
        }

        .ant-select {
            width: 200px;
        }
    }
}
</style>
